import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BaseStepComponent } from 'app/base';
import { SelectItem } from 'primeng/primeng';
import { gridSomatorio } from 'app/entity/grid-Somatorio-prestacao-conta.mode';
import { cabecalho } from 'app/entity/cabecalho-prestacao-conta.model';

@Component({
    selector: 'prestacao-conta-etapa3',
    templateUrl: './prestacao-conta-etapa3.component.html',
})
export class CrudPrestacaoContaEtapa3Component extends BaseStepComponent {

    goToNext = 0;
    bloqueioEdicao: boolean = false;

    @Input() valoresDataTablePontuacaoTotal: gridSomatorio[];
    @Input() valoresDataTableResultados: gridSomatorio[];
    @Input() cabecalhoSomatorio: cabecalho[];
    @Input() todasHipoteses: any[];
    @Input() funcaoExercida: SelectItem[] = [];
    @Input() listaFuncao: any[] = [];
    @Input() listaTelefones: any[] = [];
    @Input() listaEmails: any[] = [];
    @Input() listaEnderecos: any[] = [];
    @Input() profissional: any;
    @Input() ano: any;

    @Input() listaAquisicaoConhecimento: any[] = [];
    @Input() listaSomatorioAquisicaoConhecimento: gridSomatorio[] = [];

    @Input() listaDocencia: any[] = [];
    @Input() listaSomatorioDocencia: gridSomatorio[] = [];

    @Input() listaAtuacaoComoParticipante: any = [];
    @Input() listaSomatorioAtuacaoComoParticipante: gridSomatorio[] = [];

    @Input() listaProducaoIntelectual: any = [];
    @Input() listaSomatorioProducaoIntelectual: gridSomatorio[] = [];

    labelD = "Docência";
    labelAC = "Aquisição de Conhecimento";
    labelAP = "Atuação como Participantes (Comissão Técnicas e Profissionais)";
    labelPI = "Produção Intelectual (Livros, Artigos)";

    @Input() listaSomatorioTotal: any[] = [];

    labelEndereco = "Endereços secundários";
    labelTelefone = "Telefones secundários";
    labelEmail = "Emails secundários";

    @Output() cabecalhoSomatorioChange: EventEmitter<any> = new EventEmitter<any>();
    cadastrar = false;
    init() {
    }

    emitCabecalho() {
        this.cabecalhoSomatorioChange.emit(this.cabecalhoSomatorio);
    }
}


// WEBPACK FOOTER //
// ./src/app/prestacao-conta/crud/etapas/prestacao-conta-etapa3.component.ts